import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface FiservProcessorDetailsPageProps {
    processor: ProcessorDetails
}

const FiservConfigurationCard = ({ processor }: FiservProcessorDetailsPageProps) => {
    const options = processor.options as Record<string, any> | null

    return (
        <Card className="mb-6">
            <CardHeader><CardTitle>Fiserv Configuration</CardTitle></CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">Merchant ID</p>
                        <p className="font-mono text-sm">{options?.merchantId || 'Not configured'}</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">API Key</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">API Secret</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Auth Method</p>
                        <Badge variant="secondary">HMAC-SHA256</Badge>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Environment</p>
                        <Badge variant={options?.testMode ? 'outline' : 'default'}>
                            {options?.testMode ? 'Certification' : 'Production'}
                        </Badge>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export const FiservProcessorDetailsPage = ({ processor }: FiservProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader type="fiserv" processor={processor} />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <FiservConfigurationCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
        </>
    )
}
